let recommendationTimeoutId;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelector(".drawer-close").addEventListener('click', () => this.close.bind(this));
   
  } 

  getRecommendationAndAddToMarkup() {
    clearTimeout(recommendationTimeoutId);

    recommendationTimeoutId = setTimeout(() => {
      const recommendationSection = document.querySelector('#product-recs').dataset.sectionId;
      const productId = this.querySelector(".cart-item").dataset.id;
  
  
      if (productId) {
        async function fetchProductRecommendations() {
          try {
              const response = await fetch(`${window.routes.productRecommendations}?section_id=${recommendationSection}&product_id=${productId}&limit=10&intent=related`);
              
              const html = await response.text();
              return html;
          } catch (error) {
              console.log(error);
          }
        }
  
        fetchProductRecommendations().then(html => {
  
          if (html) {
              const ajaxRecommendationSection = this.querySelector('.product-ajax-cart__wrapper');
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const productRecs = doc.querySelector('#product-recs');
      
              
              const ymalProducts = doc.querySelectorAll(".product-ajax-cart__item");
    
              ymalProducts.forEach(product => {
  const addButton = product.querySelector("#ymal-add");
  
  addButton.addEventListener("click", (e) => {
    e.preventDefault();
    
    const productId = product.getAttribute("data-product-id");
    addButton.classList.add("clicked-btn");
    addButton.setAttribute("disabled", true);
    
    // Hide "Add to Cart" text and show "Added" text
    addButton.querySelector(".add-to-cart-text").style.display = "none";
    addButton.querySelector(".added-text").style.display = "inline-flex";

    let formData = {
      'items': [{
        'id': productId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(result => {
      fetch(`${window.Shopify.routes.root}cart?view=get-json`)
        .then((resp) => resp.json())
        .then((data) => {
          const cartCounter = document.querySelector(".cart-count-bubble span");
          cartCounter.textContent = data.item_count;
        })
        .catch((error) => {
          console.error(error);
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
});

    
              if (ajaxRecommendationSection && productRecs) {
                  ajaxRecommendationSection.replaceChild(productRecs, ajaxRecommendationSection.firstElementChild);
              }
    
              if (window.initAjaxSlider) {
                window.initAjaxSlider()
              }   
          }
         });
         
      } 
    }, 50);
  }
  async getCartData() {
    const response = await fetch(`${window.routes.cart}?view=get-json`);
    const json = await response.json();
    const res = json;
    return res;
  }

  connectedCallback() {
    this.getRecommendationAndAddToMarkup();
   }


  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    // cartLink.addEventListener('click', (event) => {
    // event.preventDefault();
    //  this.open(cartLink)
    //  });
    // cartLink.addEventListener('keydown', (event) => {
    //   if (event.code.toUpperCase() === 'SPACE') {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      if (window.initAjaxSlider) {
        window.initAjaxSlider()
      }
      
      this.classList.add('active')
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // console.log(777, this.getSectionsToRender())
    // this.renderContents();
    // this.getSectionsToRender().forEach((section => {
    //   const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
    //   sectionElement.innerHTML =
    //       this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    // }));
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    this.getRecommendationAndAddToMarkup();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.querySelector(".drawer-close").addEventListener('click', () => this.close());
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
